import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import AdminNavbar from "../components/Navbar";
import LedBasicsImg from "../assets/products/3.png";

const LedBasics = () => {
  const navigate = useNavigate();

  return (
    <>
      <AdminNavbar />

      <div className="min-h-screen bg-gray-100 p-6">
        {/* Page Title */}
        <h1 className="text-3xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-800 to-pink-500 mb-10">
          LED Basics 💡
        </h1>

        <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-8">
          {/* Intro Section */}
          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              What is LED Lighting?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              LED stands for <span className="font-semibold">Light Emitting Diode</span>.
              Unlike traditional incandescent bulbs, LEDs use semiconductor technology to
              produce light efficiently. They consume far less energy and last much longer,
              making them a smart choice for both homes and businesses.
            </p>
          </motion.section>

          {/* Benefits Section */}
          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <h2 className="text-2xl font-bold text-gray-800 mb-3">Benefits of LEDs</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
              <li>
                <span className="font-semibold">Energy Efficient:</span> LEDs use up to 80%
                less electricity than incandescent bulbs.
              </li>
              <li>
                <span className="font-semibold">Long Lifespan:</span> LEDs can last 25,000–50,000
                hours compared to 1,000 hours for traditional bulbs.
              </li>
              <li>
                <span className="font-semibold">Eco-Friendly:</span> They contain no mercury and
                emit minimal heat, reducing your carbon footprint.
              </li>
              <li>
                <span className="font-semibold">Instant Light:</span> LEDs turn on instantly
                without warm-up time.
              </li>
              <li>
                <span className="font-semibold">Durable:</span> Solid-state construction makes
                them resistant to shocks and vibrations.
              </li>
            </ul>
          </motion.section>

          {/* How LEDs Work Section */}
          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <h2 className="text-2xl font-bold text-gray-800 mb-3">How Do LEDs Work?</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              LEDs produce light when an electrical current passes through a semiconductor,
              causing electrons to release photons (light particles). The color and brightness
              depend on the materials used and the current supplied.
            </p>
          </motion.section>

          {/* Tips Section */}
          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            <h2 className="text-2xl font-bold text-gray-800 mb-3">Choosing the Right LED</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
              <li>
                <span className="font-semibold">Color Temperature:</span> Choose “Warm White” for
                cozy areas and “Cool White” for task lighting.
              </li>
              <li>
                <span className="font-semibold">Lumens, not Watts:</span> Lumens measure brightness
                — higher lumens mean brighter light.
              </li>
              <li>
                <span className="font-semibold">Dimmable LEDs:</span> Check compatibility with your
                dimmer switch.
              </li>
              <li>
                <span className="font-semibold">Quality Matters:</span> Look for trusted brands and
                ENERGY STAR certifications.
              </li>
            </ul>
          </motion.section>

          {/* Image Section */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.8, duration: 0.5 }}
            className="text-center mt-8"
          >
            <img
              src={LedBasicsImg}
              alt="LED Basics"
              className="rounded-2xl shadow-md mx-auto w-full max-w-3xl"
            />
            <p className="text-gray-500 text-sm mt-3">
              Learn the fundamentals of LED lighting and transform your space efficiently.
            </p>
          </motion.div>

          {/* Browse Products CTA — filters the shop to LED Bulb Series,
              reusing the existing product/category filtering system */}
          <div className="text-center mt-8">
            <button
              type="button"
              onClick={() => navigate("/shop", { state: { category: "LED BULB SERIES" } })}
              className="inline-block bg-gradient-to-r from-purple-800 to-pink-500 text-white font-medium px-6 py-3 rounded-full shadow-md hover:shadow-lg transition"
            >
              Browse Products
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LedBasics;
